import { Checkbox } from "@mui/material";
import React from "react";

import { ariaLabel as ariaLabelConst } from "src/constants";

type Props = {
  isMaxSelectedReached: boolean;
  checked: boolean;
  id: string;
  ariaLabel?: string;
  onChange: (checked: boolean) => void;
};

export const ListSelectionCheckbox = ({
  isMaxSelectedReached,
  checked,
  onChange,
  id,
  ariaLabel = ariaLabelConst.listSelectAllCheckbox,
}: Props) => {
  const isDisabled = isMaxSelectedReached && !checked;

  return (
    <Checkbox
      id={id}
      size="small"
      disabled={isDisabled}
      sx={(theme) => ({
        color: isDisabled ? `${theme.palette.primary.contrastText} !important` : undefined,
      })}
      slotProps={{
        input: {
          "aria-label": ariaLabel,
        },
      }}
      checked={checked}
      onChange={(e) => {
        onChange(e.target.checked);
      }}
    />
  );
};
